function Transformation() {
  return (
    <div className="section">
      <div className="container">
        <h1 className="title">Organizational Transformation</h1>
        <p className="text">
          Helping organizations improve systems, structure, and efficiency.
        </p>
      </div>
    </div>
  );
}

export default Transformation;